// extracted by mini-css-extract-plugin
module.exports = {"question":"descriptor_question__4Ul-H","questionHeader":"descriptor_questionHeader__1aqRE","answer":"descriptor_answer__SRWZZ"};